"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterReminder = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const config_1 = require("@/config/dictionary/config");
const dictionary_1 = require("@/config/dictionary");
const location_1 = require("@/pages/index/select/location");
const DetailTitle_vue_1 = __importDefault(require("../DetailTitle.vue"));
const overdue_1 = __importDefault(require("../../api/overdue"));
const dict_1 = require("../../select/dict");
const select_1 = require("../../select");
const overdue_2 = require("../../select/overdue");
const complex_plugin_1 = require("complex-plugin");
const file_1 = require("../../utils/file");
const config_2 = __importDefault(require("@/config"));
class LetterReminder extends complex_data_1.ComplexList {
    getInfo(record) {
        return new Promise((resolve) => {
            record.fileList = [];
            (0, file_1.getFile)(record.id, 'letterReminder').then((fileRes) => {
                record.fileList = fileRes.file;
                resolve({ status: 'success' });
            }).catch(() => {
                resolve({ status: 'success' });
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            overdue_1.default.overdueLetterReminderChange.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    buildOverdue() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueLetterReminderBuildOverdue.require({
                overdueRecordId: this.$getExtra('overdueRecordId')
            }).then((res) => {
                if (res.data.data) {
                    complex_plugin_1.notice.showMsg('生成成功！', 'success');
                }
                else {
                    complex_plugin_1.notice.showMsg('生成失败！', 'success');
                }
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve(res);
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    buildCollection() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueLetterReminderBuildCollection.require({
                overdueRecordId: this.$getExtra('overdueRecordId')
            }).then((res) => {
                if (res.data.data) {
                    complex_plugin_1.notice.showMsg('生成成功！', 'success');
                }
                else {
                    complex_plugin_1.notice.showMsg('生成失败！', 'success');
                }
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve(res);
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.LetterReminder = LetterReminder;
const mainData = new LetterReminder({
    name: '函催',
    prop: 'letterReminder',
    module: {
        dictionary: {
            layout: {
                default: {
                    grid: 12,
                    label: 8,
                    content: 16
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'overdueRecordId',
                    name: '逾期记录ID',
                    originProp: 'overdueRecordId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber
                        }
                    }
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.CASE_COLLECTION_TYPE, {
                    prop: 'caseCollectionType',
                    name: '函催类型',
                    originProp: 'caseCollectionType',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'caseCollectionFileName',
                    name: '催收文件',
                    originProp: 'caseCollectionFileName',
                    originFrom: 'list',
                    format(value, { originData }) {
                        return {
                            name: value,
                            url: originData.caseCollectionFilePath
                        };
                    },
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4),
                            pureRender({ text }) {
                                if (text && text.url) {
                                    return (0, vue_1.h)('span', {}, [
                                        (0, vue_1.h)('a', {
                                            href: text.url,
                                            target: '_blank'
                                        }, '下载')
                                    ]);
                                }
                            },
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.SEND_TYPE, {
                    prop: 'sendType',
                    name: '发送方式',
                    originProp: 'sendType',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true,
                            observe(target, prop, val) {
                                if (prop === 'sendType') {
                                    if (val === 'ON_LINE') {
                                        // 线上
                                        target.show('onlineMethod');
                                        target.hidden('expressNumber');
                                    }
                                    else {
                                        target.hidden('onlineMethod');
                                        target.show('expressNumber');
                                    }
                                }
                            },
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'expressNumber',
                    name: '快递单号',
                    originProp: 'expressNumber',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 80
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'onlineMethod',
                    name: '线上方式',
                    originProp: 'onlineMethod',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 80
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'sendTime',
                    name: '发送时间',
                    originProp: 'sendTime',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'date',
                            required: true,
                            option: {
                                time: {}
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'provinceCode',
                    showProp: {
                        default: 'value',
                        list: 'label'
                    },
                    name: '省市',
                    originProp: 'provinceCode',
                    originFrom: 'list',
                    format(value, { originData }) {
                        const cityCode = originData.cityCode;
                        const provinceValue = location_1.location.getItem(value);
                        const valueList = [value, cityCode];
                        if (cityCode && provinceValue.children) {
                            const cityValue = provinceValue.children.find(item => item.value === cityCode);
                            return {
                                value: valueList,
                                label: cityValue.label
                            };
                        }
                        return {
                            value: valueList,
                            label: provinceValue.label
                        };
                    },
                    post(value, { targetData }) {
                        const [provinceCode, cityCode] = value;
                        targetData.cityCode = cityCode;
                        return provinceCode;
                    },
                    mod: {
                        edit: {
                            type: 'cascader',
                            required: true,
                            option: {
                                list: location_1.location.getList()
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'address',
                    name: '详细地址',
                    originProp: 'address',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 100
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactName',
                    name: '有效联系人',
                    originProp: 'contactName',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 100
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactPhone',
                    name: '联系电话',
                    originProp: 'contactPhone',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 100
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.letterReminderSendStatus, {
                    prop: 'sendStatus',
                    name: '发送状态',
                    originProp: 'sendStatus',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(select_1.baseSwitch, {
                    prop: 'receiveFlag',
                    name: '是否收到',
                    originProp: 'receiveFlag',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'remark',
                    name: '无',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'fileList',
                    name: '附件',
                    originProp: 'fileList',
                    originFrom: 'list',
                    post(value) {
                        return value.map(item => item.data);
                    },
                    layout: {
                        default: {
                            grid: 24,
                            label: 4,
                            content: 20
                        }
                    },
                    mod: {
                        edit: {
                            type: 'file',
                            multiple: true,
                            required: false,
                            local: {
                                target: {
                                    props: {
                                        complex: true
                                    }
                                }
                            },
                            option: {
                                accept: config_2.default.file,
                                upload(fileList) {
                                    return (0, file_1.uploadFile)(fileList, 'letterReminder');
                                }
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'createdBy',
                    name: '创建人',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '无',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '无',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueLetterReminderList.require({
                overdueRecordId: this.$getExtra('overdueRecordId')
            }).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = (0, vue_1.defineComponent)({
    name: 'LetterReminder',
    components: {
        DetailTitle: DetailTitle_vue_1.default,
        ListView: ListView_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        unOperate: {
            type: Boolean,
            required: false
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            collapse: this.defaultCollapse,
            mainData: mainData,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                menu: {
                    list: [
                        {
                            name: '发送记录',
                            prop: this.unOperate ? 'change-emit' : 'change'
                        }
                    ]
                },
                search: false,
                edit: {
                    modal: {
                        optionProps: {
                            width: 960
                        }
                    }
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.mainData.$setExtra('overdueRecordId', this.id);
                    this.mainData.$loadData(true);
                }
            }
        }
    },
    beforeUnmount() {
        mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onSend(type) {
            if (type === 'overdue') {
                this.mainData.$triggerMethod('buildOverdue');
            }
            else if (type === 'collection') {
                this.mainData.$triggerMethod('buildCollection');
            }
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
